import { h } from './h';
import { Component, TOptions } from './component';

export class Confirm extends Component {
  public buttonCancel: string;
  public buttonConfirm: string;

  constructor(options: TOptions) {
    super(options);
    this.buttonCancel = options.buttonCancel ? options.buttonCancel : 'Cancel';
    this.buttonConfirm = options.buttonConfirm ? options.buttonConfirm : 'Confirm';
    this.injectTemplate();
    this.render();
  }

  injectTemplate() {
    const head = h('div', { class: 'head' }, [h('p', { class: 'title' }, [this.title])]);

    this.port?.appendChild(head);

    let innerContainer;

    if (this.useInnerHTML) {
      const content = h('div', { class: 'content' });
      content.innerHTML = this.content;

      innerContainer = h('div', { class: 'inner-container' }, [content]);
    } else {
      innerContainer = h('div', { class: 'inner-container' }, [h('p', { class: 'content' }, [this.content])]);
    }

    innerContainer.appendChild(
      h('div', { class: 'buttons' }, [
        h(
          'button',
          {
            class: 'cancel',
            click: () => {
              this.close();
              if (this.options.onCancel) {
                this.options.onCancel(this);
              }
            },
          },
          [this.buttonCancel]
        ),
        h(
          'button',
          {
            class: 'confirm',
            click: () => {
              this.close();
              if (this.options.onConfirm) {
                this.options.onConfirm(this);
              }
            },
          },
          [this.buttonConfirm]
        ),
      ])
    );

    this.port?.appendChild(head);
    this.port?.appendChild(innerContainer);
  }
}
